<template>
  <div class="VimeoThumbnail"
    :is="element"
    :to="route || ''"
    :style="vimeoThumbnailStyle">

    <thumbnail class="VimeoThumbnail-thumbnail"
      :image="resolvedImage"
      :tags="resolvedTags"
      :button="resolvedButton" />

  </div>
</template>

<script>
import axios from 'axios'
import { millisecondsToMinutesAndSeconds } from 'helpers'

const VIMEO_EP = 'https://vimeo.com/api/oembed.json/?url=https://vimeo.com/'

export default {
  name: 'VimeoThumbnail',

  props: {
    /**
     * The Vimeo resource ID
     */
    id: {
      type: [Number, String],
      required: true
    },

    /**
     * Image to use for the poster
     */
    image: {
      type: Object
    },

    /**
     * Vue router object
     */
    route: {
      type: Object
    },

    /**
     * Width/height ratio to prevent layout jump
     */
    ratio: {
      type: Array,
      default () {
        return [16, 9]
      }
    },

    /**
     * Whether to show the tag
     */
    showTag: {
      type: Boolean,
      default: true
    },

    /**
     * Whether to show the larger media button
     */
    showButton: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      /**
       * Video data returned from API
       * @type {Object}
       */
      data: {}
    }
  },

  computed: {
    /**
     * The top-level element
     * @return {String}
     */
    element () {
      if (this.route) return 'router-link'
      return 'div'
    },

    duration () {
      if (!this.data.duration) return
      return millisecondsToMinutesAndSeconds(this.data.duration)
    },

    /**
     * Return an object compatible with the ImageComponent
     * @return {Object}
     */
    resolvedImage () {
      // Trust the image prop to contain the correct properties
      if (this.image) return this.image

      // Use the thumbnail returned from Vimeo
      return {
        src: this.data.thumbnail_url
      }
    },

    /**
     * Tags to show on thumbnail
     * @return {Array}
     */
    resolvedTags () {
      if (!this.showTag || this.showButton) return []

      return [
        {
          icon: 'film',
          label: this.duration || ''
        }
      ]
    },

    /**
     * The larger media button
     * @return {Object}
     */
    resolvedButton () {
      if (!this.showButton) return false
      if (this.resolvedTags.length > 0) return false

      return {
        icon: 'play',
        label: 'Play film',
        meta: this.duration || ''
      }
    },

    /**
     * Add top padding to prevent layout shift
     * @return {Object}
     */
    vimeoThumbnailStyle () {
      if (!this.ratio) return {}

      const width = this.ratio[0] || this.data.width
      const height = this.ratio[1] || this.data.height
      const ratio = 100 * height / width

      return {
        'padding-top': `${ratio}%`
      }
    }
  },

  created () {
    this.init()
  },

  methods: {
    /**
     * Load video information from Vimeo
     */
    init () {
      axios.get(`${VIMEO_EP}${this.id}`)
        .then(response => {
          this.data = response.data
        })
        .catch(console.error)
    }
  }
}
</script>

<style>
.VimeoThumbnail {
  position: relative;
  display: block;
}

.VimeoThumbnail-thumbnail {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// VimeoThumbnail.vue?09a43b5e